import { render, staticRenderFns } from "./OrdenNew.vue?vue&type=template&id=0d76dba8&scoped=true&"
import script from "./OrdenNew.vue?vue&type=script&lang=js&"
export * from "./OrdenNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d76dba8",
  null
  
)

export default component.exports